import React, { useState, useEffect } from "react";

const PublicHeader = ({ onLoginOpen }) => {
  const [scrollY, setScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(12px)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          padding: isMobile 
            ? (scrollY > 50 ? "10px 20px" : "12px 20px")
            : (scrollY > 50 ? "12px 40px" : "16px 40px"),
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          WebkitBackfaceVisibility: "hidden",
          backfaceVisibility: "hidden"
        }}
      >
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          maxWidth: "1400px",
          margin: "0 auto",
          position: "relative",
          zIndex: 1
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: isMobile ? "8px" : "16px" }}>
            <a href="https://anuvadini.aicte.gov.in/" target="_blank" rel="noopener noreferrer">
              <img 
                src="/anuvadini-logo.png" 
                alt="Anuvadini Logo" 
                style={{ 
                  height: scrollY > 50 ? "50px" : "60px", 
                  width: "auto",
                  transition: "height 0.3s ease, transform 0.3s ease",
                  willChange: "height, transform",
                  cursor: "pointer"
                }} 
              />
            </a>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ 
                fontSize: isMobile 
                  ? (scrollY > 50 ? "18px" : "20px")
                  : (scrollY > 50 ? "24px" : "28px"), 
                fontWeight: 900, 
                background: "linear-gradient(135deg, #065f46, #10b981)", 
                WebkitBackgroundClip: "text", 
                WebkitTextFillColor: "transparent",
                transition: "font-size 0.3s ease"
              }}>
                {/* AgriAI Platform */}
              </span>
            </div>
          </div>
          
          {/* Desktop Navigation */}
          {!isMobile && (
            <nav style={{ 
              display: "flex", 
              gap: "32px", 
              alignItems: "center",
              position: "relative",
              zIndex: 2,
              marginRight: "60px"
            }}>
              <a 
                href="#features" 
                style={{ 
                  color: "#374151", 
                  textDecoration: "none", 
                  fontWeight: 500, 
                  transition: "all 0.3s ease",
                  fontSize: "16px"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#10b981";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#374151";
                }}
              >
                Features
              </a>
              <a 
                href="#benefits" 
                style={{ 
                  color: "#374151", 
                  textDecoration: "none", 
                  fontWeight: 500,
                  transition: "all 0.3s ease",
                  fontSize: "16px"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#10b981";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#374151";
                }}
              >
                Benefits
              </a>
              <a 
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                style={{ 
                  color: "#374151", 
                  textDecoration: "none", 
                  fontWeight: 500,
                  transition: "all 0.3s ease",
                  fontSize: "16px",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#10b981";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#374151";
                }}
              >
                Contact
              </a>
              <button 
                onClick={() => onLoginOpen?.()}
                style={{
                  background: "linear-gradient(135deg, #10b981, #059669)",
                  color: "white",
                  padding: scrollY > 50 ? "10px 24px" : "12px 28px",
                  borderRadius: "50px",
                  border: "2px solid transparent",
                  fontWeight: 700,
                  cursor: "pointer",
                  boxShadow: "0 6px 20px rgba(16, 185, 129, 0.4)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  fontSize: scrollY > 50 ? "15px" : "16px",
                  position: "relative",
                  zIndex: 10,
                  whiteSpace: "nowrap",
                  minWidth: "140px",
                  textAlign: "center"
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-3px) scale(1.05)";
                  e.target.style.boxShadow = "0 10px 30px rgba(16, 185, 129, 0.5)";
                  e.target.style.background = "linear-gradient(135deg, #059669, #047857)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0) scale(1)";
                  e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
                  e.target.style.background = "linear-gradient(135deg, #10b981, #059669)";
                }}
              >
                Login
              </button>
            </nav>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                zIndex: 10
              }}
              aria-label="Toggle menu"
            >
              <span style={{
                width: "24px",
                height: "2px",
                background: "#374151",
                transition: "all 0.3s ease",
                transform: isMobileMenuOpen ? "rotate(45deg) translateY(6px)" : "none"
              }} />
              <span style={{
                width: "24px",
                height: "2px",
                background: "#374151",
                transition: "all 0.3s ease",
                opacity: isMobileMenuOpen ? 0 : 1
              }} />
              <span style={{
                width: "24px",
                height: "2px",
                background: "#374151",
                transition: "all 0.3s ease",
                transform: isMobileMenuOpen ? "rotate(-45deg) translateY(-6px)" : "none"
              }} />
            </button>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobile && isMobileMenuOpen && (
          <nav style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            animation: "slideDown 0.3s ease"
          }}>
            <a 
              href="#features"
              onClick={() => setIsMobileMenuOpen(false)}
              style={{ 
                color: "#374151", 
                textDecoration: "none", 
                fontWeight: 500,
                fontSize: "16px",
                padding: "12px 16px",
                borderRadius: "8px",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(16, 185, 129, 0.1)";
                e.target.style.color = "#10b981";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#374151";
              }}
            >
              Features
            </a>
            <a 
              href="#benefits"
              onClick={() => setIsMobileMenuOpen(false)}
              style={{ 
                color: "#374151", 
                textDecoration: "none", 
                fontWeight: 500,
                fontSize: "16px",
                padding: "12px 16px",
                borderRadius: "8px",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(16, 185, 129, 0.1)";
                e.target.style.color = "#10b981";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#374151";
              }}
            >
              Benefits
            </a>
            <a 
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                setIsMobileMenuOpen(false);
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              style={{ 
                color: "#374151", 
                textDecoration: "none", 
                fontWeight: 500,
                fontSize: "16px",
                padding: "12px 16px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(16, 185, 129, 0.1)";
                e.target.style.color = "#10b981";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#374151";
              }}
            >
              Contact
            </a>
            <button 
              onClick={() => {
                onLoginOpen?.();
                setIsMobileMenuOpen(false);
              }}
              style={{
                background: "linear-gradient(135deg, #10b981, #059669)",
                color: "white",
                padding: "12px 24px",
                borderRadius: "50px",
                border: "2px solid transparent",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 6px 20px rgba(16, 185, 129, 0.4)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                fontSize: "16px",
                textAlign: "center",
                marginTop: "8px"
              }}
            >
              Login
            </button>
          </nav>
        )}
      </header>

      
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </>
  );
};

export default PublicHeader;